import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Input } from '@/components/ui/input';

const STATUSES = ['Available', 'Limited', 'Unavailable', 'Seasonal'];
const COLORS = { Available: 'text-forest', Limited: 'text-gold-dark', Unavailable: 'text-red-600', Seasonal: 'text-brown' };

export default function FarmAvailability() {
  const [rows, setRows] = useState([]);

  const load = () => api.get('/farm/availability').then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const update = (pid, key, val) => setRows((prev) => prev.map((r) => (r.product_id === pid ? { ...r, [key]: val } : r)));

  const save = async (row) => {
    try {
      await api.put(`/farm/availability/${row.product_id}`, { status: row.status, quantity: row.quantity === '' ? null : parseFloat(row.quantity), expected_return: row.expected_return || '' });
      toast.success(`${row.name} availability saved`);
    } catch { toast.error('Failed to save'); }
  };

  return (
    <div data-testid="farm-availability">
      <p className="font-manrope text-dark/60 mb-6">Update what you can supply this week. FarmBox uses this to plan the storefront, but retains final control over what's offered.</p>
      <div className="bg-white rounded-2xl border border-forest/10 overflow-hidden">
        {rows.length === 0 ? (
          <p className="p-12 text-center font-manrope text-dark/50">No approved products yet. Add products and get them approved to set weekly availability.</p>
        ) : (
          <div className="divide-y divide-forest/10">
            {rows.map((row) => (
              <div key={row.product_id} className="p-5 grid md:grid-cols-4 gap-4 items-center" data-testid={`avail-${row.product_id}`}>
                <div><h3 className="font-playfair text-lg font-bold text-dark">{row.name}</h3><span className="font-manrope text-xs text-dark/50">{row.unit}</span></div>
                <select value={row.status} onChange={(e) => update(row.product_id, 'status', e.target.value)} className={`bg-cream border border-forest/20 rounded-xl px-4 py-2.5 font-manrope font-semibold ${COLORS[row.status]}`} data-testid={`avail-status-${row.product_id}`}>
                  {STATUSES.map((s) => <option key={s}>{s}</option>)}
                </select>
                <Input type="number" placeholder="Quantity" className="bg-cream border-forest/20" value={row.quantity ?? ''} onChange={(e) => update(row.product_id, 'quantity', e.target.value)} data-testid={`avail-qty-${row.product_id}`} />
                <button onClick={() => save(row)} className="btn-primary py-2.5 text-sm justify-center" data-testid={`avail-save-${row.product_id}`}>Save</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
